import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ObservationService } from '../../../../observations/services/observation.service';
import { BehaviorSubject, Observable, ReplaySubject, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LocationModel } from '../../../../locations/models/location.model';
import { Router } from '@angular/router';
import { RouteService } from '@kaiser-software/chassis-core';

export const MAIN_CATEGORY_COLUMN_NAME = 'main_category';
export const LOCATION_COLUMN_NAME      = 'location';

interface Response {
    data: Array<number>,
    labels: Array<string>,
    colors: Array<string>,
}

interface Chart {
    data: Array<number>,
    labels: Array<string>,
    colors: Array<string>,
}

@Component({
    selector: 'ewsg-location-observation-chart',
    templateUrl: './location-observation-chart.component.html',
    styleUrls: ['./location-observation-chart.component.scss']
})
export class LocationObservationChartComponent implements OnInit, OnChanges, OnDestroy {

    @Input() public location: LocationModel;

    @Input() public filters: {
        startDate?: number,
        endDate?: number,
    } = {};

    @Input() public reload;

    public chart$ = new ReplaySubject<Chart>(1);

    public loading$ = new BehaviorSubject(true);

    protected subscription = new Subscription();

    constructor(
        protected observationService: ObservationService,
        protected router: Router,
        protected routeService: RouteService,
    ) {
        //
    }

    public ngOnInit(): void {
        this.loadChartData();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.filters && !changes.filters.isFirstChange()) {
            this.loadChartData();
        }

        if (changes.reload) {
            this.loadChartData();
        }
    }

    public loadChartData(): void {
        this.loading$.next(true);

        this.subscription.add(
            this.sendLoadChartDataRequest()
                .pipe(
                    map((data) => {
                        Object.assign(data, {
                            colors: [{
                                backgroundColor: data.colors
                            }]
                        });

                        return data;
                    }),
                )
                .subscribe((chart: Chart) => {
                    this.chart$.next(chart);
                }, () => {
                    //
                }, () => {
                    this.loading$.next(false);
                })
        );
    }

    protected sendLoadChartDataRequest(): Observable<Response> {
        const base = this.observationService.getBaseEndpoint();
        const url  = `${base}/widgets/location-observations/${this.location.id}`;

        const params = this.filters;

        return this.observationService
            .custom('get', url, {}, params)
            .pipe(
                take(1),
                map((response: Response) => {
                    return response;
                }),
            );
    }

    public chartClicked(e: any): void {
        if (e.active[0]) {
            const title = e.active[0]._chart.config.data.labels[e.active[0]._index];
            const route = this.routeService.route('observations.index');

            this.router.navigateByUrl(
                `${route}?search=${MAIN_CATEGORY_COLUMN_NAME}:${title}&search=${LOCATION_COLUMN_NAME}:${this.location.name}&orderBy=created_at&orderDir=desc`
            );
        }
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/dashboards/pages/account/location-observation-chart/location-observation-chart.component.ts